import { render, staticRenderFns } from "./frontFormDatos.vue?vue&type=template&id=bf7c13bc&"
import script from "./frontFormDatos.vue?vue&type=script&lang=js&"
export * from "./frontFormDatos.vue?vue&type=script&lang=js&"
import style0 from "./frontFormDatos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports